import { render } from "./FeatureAdd.vue?vue&type=template&id=4ed34db8"
import script from "./FeatureAdd.vue?vue&type=script&lang=js"
export * from "./FeatureAdd.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4ed34db8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ed34db8', script)) {
    api.reload('4ed34db8', script)
  }
  
  module.hot.accept("./FeatureAdd.vue?vue&type=template&id=4ed34db8", () => {
    api.rerender('4ed34db8', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/FeatureAdd.vue"

export default script